<template>
    <div v-if="appReady">
      <!-- btn nav -->
      <div>
        <b-button class="mr-2" :variant="currentStep === 'step1' ? 'success' : 'secondary'" :disabled="step1.disabled" @click="switchStep('step1')">1 - {{$t('label.endorser')}}</b-button>
        <b-button class="mr-2" :variant="currentStep === 'step2' ? 'success' : 'secondary'" :disabled="step2.disabled" @click="switchStep('step2')">2 - {{$t('label.yourSignature')}}</b-button>
        <b-button class="mr-2" :variant="currentStep === 'step3' ? 'success' : 'secondary'" :disabled="step3.disabled" @click="switchStep('step3')">3 - {{$t('label.submitApplication')}}</b-button>
      </div>
      <div v-if ="currentStep === 'step2'">
        <step-2 v-on:changePage="setNextPage" v-on:changeStep ="switchStep" :btnNextStep="btnNextStep3" from="endorser"/>
      </div>
      <div v-else-if ="currentStep === 'step3'">
        <step-3 v-on:changePage="setNextPage" v-on:changeStep ="switchStep" :btnNextStep="btnNextStep4" from="endorser"/>
      </div>
      <div v-else>
        <step-1 v-on:changePage="setNextPage" v-on:changeStep ="switchStep" :btnNextStep="btnNextStep2" from="endorser"/>
      </div>
    </div>
</template>

<script>
import Step1 from './Step1.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import { globalF } from './Helpers';

export default {  
mixins: [globalF],  
props: [],
data() { 
  return {
    step1 : {disabled: false },
    step2 : {disabled: true },
    step3 : {disabled: true },
    currentStep : 'step1',
    btnNextStep2: false,
    btnNextStep3: false,
    btnNextStep4: false,
    appReady: false
}},
mounted () {
        this.spinner = true;
        let promise = this.setAxios('EndorserProcess');
        promise.then((value) => {
          if (value) {
            this.validateProcessData(value);            
          }  
          else {
            this.appReady = true;
          } 
        });
},
computed: {
    url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  }
},
methods:{
    setJsonData: function (from, processData) {
      let arrProcessData = [];
      if (processData) {

        if (from === 'addEndorserData') {
          arrProcessData = [[]];
        }

        for (let i=0; i < processData.length; i++ ) {
          let stepData = processData[i];
          let processDataJson = JSON.parse(stepData.JsonData);
          if (processDataJson) {
            arrProcessData.push(processDataJson);
          }  
        }

      }

      this.$store.commit(from, arrProcessData);
    },
    validateProcessData: function (objData) {

      this.setJsonData('addEndorserData', objData.endData);
      this.setJsonData('addProcessData', objData.processData);

      let processData = objData.endData;
      
      let length = processData ? processData.length : 0;
      let lastStep = length;

      if (lastStep === 0 || lastStep === 1 || lastStep === 2) {

        this.step1.disabled = false;
        this.btnNextStep1 = true;

        if (lastStep === 1 || lastStep === 2) {

          this.btnNextStep2 = true;
          this.step2.disabled = false;

          if (lastStep === 2) {
            this.btnNextStep3 = true;
            this.step3.disabled = false;
          }
        }

        let nextStep = lastStep + 1;

        this.currentStep = "step"+nextStep;
        this.spinner = false;
        this.appReady = true;

      }

       if (lastStep === 3) {
        this.$store.commit("addStatus", 3);
        this.setNextPage('MessageCenter');
      }
      /*if (lastStep === 1 || lastStep === 2) {

        this.step2.disabled = false;
        this.btnNextStep2 = true;

        if (lastStep === 2) {

          this.btnNextStep3 = true;
          this.step3.disabled = false;
        }

        let nextStep = lastStep + 1;

        this.currentStep = "step"+nextStep;
        this.spinner = false;
        this.appReady = true;
      }*/
      
    },
  setNextPage(page) {      
    this.$emit('changePage', page);        
  },
  switchStep(step) {
    this.currentStep = step;
  }
},
components: {
    Step1,
    Step2,
    Step3
  }
}
</script>